import { Icon } from "./Icon.tsx";

/** "Table view" toggle icon for PasteDailySeries.tsx's chart/table switch. */
export function TableModeIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M3 10h18" />
      <path d="M3 15h18" />
      <path d="M9 4v16" />
    </Icon>
  );
}
